import { Component, HostListener } from '@angular/core';
import { WizardService, WizardStep } from './wizard.service';

@Component({
  selector: 'pgs-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent {

  get steps(): WizardStep[] {
      return this.wizardService.steps;
  }
  get currStep(): number {
      return this.wizardService.currStep;
  }
  scrolling: boolean;
  constructor(private wizardService: WizardService) { }

  // ngOnInit() {
    // this.wizardService.steps.subscribe(s => this.steps = s);
    // this.wizardService.currStep.subscribe(cs => this.currStep = cs);
  // }

  @HostListener('window:scroll')
	onScroll(): void {
		this.scrolling = window.scrollY > 0;
	}
}
